import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapAllSections } from './helpers';

export const useGetSections = (filters: string[] = [], enabled = true) =>
  useQuery({
    queryKey: queryKeys.sections.all(filters),
    queryFn: () => fetchSections(filters),
    enabled,
  });

const fetchSections = async (filters: string[] = []) => {
  const response = await requestCCApi({
    url: `/sections${generateQuery(
      ['sectionTypes'],
      concat(filters, 'pageSize=0'),
    )}`,
  });

  return mapAllSections(response.data);
};
